// extracted by mini-css-extract-plugin
export default {"container":"LoadingContainer_container__Ltmad","message":"LoadingContainer_message__AQTxZ"};